import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const AgentCardExtraContext = createContext(null);
export function AgentCardExtraProvider({ render, children }) {
    return _jsx(AgentCardExtraContext.Provider, { value: render, children: children });
}
export function useAgentCardExtra() {
    return useContext(AgentCardExtraContext);
}
//# sourceMappingURL=agentCardSlot.js.map